import { HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { McticHttpClient } from '@mctic/ng-core';
import { RelatorioConclusivo } from '../shared/model/relatorio-conclusivo.model';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})

export class RelatorioConclusivoService {

  private readonly endpoint = '/sepin-backend/rest/relatorio-conclusivo';

  constructor(
    private readonly http: McticHttpClient) {
  }

  obterRelatorioConclusivo(): Observable<RelatorioConclusivo> {
    return this.http.get<RelatorioConclusivo>(`${this.endpoint}/enviado`, );
  }

  cadastrar(relatorioConclusivo: RelatorioConclusivo, arquivo: File) {
    const headers = new HttpHeaders();
    headers.append('Content-Type', null);
    const formData: FormData = new FormData();
    formData.append(
      'relatorioConclusivo',
      new Blob([JSON.stringify(relatorioConclusivo)], {
        type: 'application/json'
      })
    );
    formData.append('arquivo', arquivo);
    return this.http.post(this.endpoint, formData, {headers});
  }

}
